// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './components/app/App-Component'
import router from './router'

Vue.use(Vuex)
Vue.config.productionTip = false

const store = new Vuex.Store({
  state: {
    english: true
  },
  getters: {
    english: state => state.english
  },
  mutations: {
    selectEn (state) {
      state.english = true
    },
    selectDe (state) {
      state.english = false
    }
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  },
  store: store
})



// WEBPACK FOOTER //
// ./src/main.js